module.exports = __webpack_public_path__ + "static/hunter-douglas-shutters-c45f16cff288024354d63d099f5e305c.png";